import React from 'react';
import '../../styles/components/AsperaDatePicker.scss';
import DatePicker, { registerLocale } from 'react-datepicker';
import { enUS, de, es, fr, ja, ko, ru, zhCN, zhTW } from 'date-fns/locale';
import { language } from '../../services/LanguageService';
import { DatePickerInput, InlineNotification } from '../Carbon';
import { AsperaError } from '../../classes/AsperaError';
import { FloatingPortal } from '@floating-ui/react';
import { getRandomId } from '../../helpers/helpers';
registerLocale('en-us', enUS);
registerLocale('de-de', de);
registerLocale('es-es', es);
registerLocale('fr-fr', fr);
registerLocale('ja-jp', ja);
registerLocale('ko-kr', ko);
registerLocale('ru-ru', ru);
registerLocale('zh-cn', zhCN);
registerLocale('zh-tw', zhTW);
/**
 * React Component
 *
 * The AsperaTabs renders the tabs via a simple array.
 *
 * @example
 * ```javascript
 * <AsperaTabs items={this.tabs} />
 * ```
 */
export class AsperaDatePicker extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: false,
        };
        this.triggerOnChange = (value) => {
            const { onChange } = this.props;
            if (typeof onChange === 'function') {
                onChange(value);
            }
        };
        this.convertDateFormat = (format) => {
            return format.replace('m', 'MM').replace('d', 'dd').replace('Y', 'yyyy');
        };
    }
    componentDidCatch(error) {
        new AsperaError('AsperaDatePicker: encountered error', error);
        this.setState({ error: true });
    }
    render() {
        const { className, dateFormat, onKeyUp, invalidText, id, invalid, disabled, dataAuto, labelText, required, placeholder, value, minDate, maxDate, onBlur } = this.props;
        const { error } = this.state;
        if (error) {
            return React.createElement(InlineNotification, { kind: "error", lowContrast: true, hideCloseButton: true, title: language.get('forms.datePickerError') });
        }
        return (React.createElement("div", { className: `aspera-date-picker ${className ? className : ''}`, "data-auto": "date-picker-wrapper", id: id },
            React.createElement(DatePicker, { locale: language.getCurrentLanguage().code, dateFormat: dateFormat || this.convertDateFormat(language.getCurrentLanguage().dateFormat), selected: value ? new Date(value) : undefined, onChange: (value) => {
                    this.triggerOnChange((value === null || value === void 0 ? void 0 : value.toISOString()) || '');
                }, disabled: disabled, required: required, allowSameDay: true, minDate: minDate ? new Date(minDate) : undefined, maxDate: maxDate ? new Date(maxDate) : undefined, calendarClassName: "aspera-date-picker--calendar", popperPlacement: "bottom-start", placeholderText: placeholder, onBlur: onBlur, popperContainer: FloatingPortal, popperProps: {
                    strategy: 'fixed',
                }, customInput: React.createElement(DatePickerInput, { onKeyUp: onKeyUp, onBlur: onBlur, autoComplete: 'off', invalidText: invalidText, invalid: invalid, disabled: disabled, "data-auto": dataAuto, labelText: labelText || '', required: required, placeholder: placeholder, id: `date-${getRandomId()}` }) })));
    }
}
;
